import { useContext } from "react";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { AppContext } from "../App";
import { t } from "../i18n";
import { useWizardNavigation } from "../hooks/useWizardNavigation";

export const DamageType = () => {
	const { nextPage, previousPage } = useWizardNavigation();

	return (
		<>
			<Header />
			<Content />
			<Footer
			nextPage={nextPage}
			previousPage={previousPage}
			clearOnBack={["damageType"]}
		/>
		</>
	);
};

const Content = () => {
	const { data, setData, isTransitioning } = useContext(AppContext);

	const updateDamageType = (damageType) => () => {
		setData((prev) => ({
			...prev,
			damageType,
			damageArea: damageType === "large" ? "replacement" : null,
		}));
	};

	return (
		<div
			className={
				"content kensei_03" + (isTransitioning ? " fade-in" : "")
			}
		>
			<div className="content_damage_type">
				<div className="content_title">
					<h2 className="select_damage_type">
						<strong>{t("Indica el tipo de daño")}</strong>
					</h2>
				</div>
				<div className="damage_type_options">
					<div
						className={
							"small_damage_type kensei_03" +
							(data.damageType === "small" ? " selected" : "")
						}
						onPointerDown={updateDamageType("small")}
					>
						<img
							src="resources/img/small_damage.png"
							alt="Menor que una moneda de 2€"
						/>
						<p>
							<strong>{t("Menor")}</strong>{" "}
							{t("que una moneda de 2€")}
						</p>
					</div>
					<div
						className={
							"large_damage_type kensei_03" +
							(data.damageType === "large" ? " selected" : "")
						}
						onPointerDown={updateDamageType("large")}
					>
						<img
							src="resources/img/large_damage.png"
							alt="Mayor que una moneda de 2€"
						/>
						<p>
							<strong>{t("Mayor")}</strong>{" "}
							{t("que una moneda de 2€")}
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};
